import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";

import { TOKEN_NAME } from "../../../constants";
import { doSignIn, doSignInCompany, doSignUp, doGetProfile, doUpdateUploadOrderTemplate } from "./thunk";

const parseToken = token => {
  if (!token) return undefined;
  let user;
  try {
    user = jwtDecode(token);
  } catch (e) {
    console.log(e);
  }
  return user;
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isFetching: false,
    authenticated: !!Cookies.get(TOKEN_NAME),
    redirectUrl: null,
    inviteCode: null,
    userData: null,
  },
  reducers: {
    doLogout: state => {
      Cookies.remove(TOKEN_NAME);
      state.authenticated = false;
    },
    setRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },
    setInviteCode: (state, action) => {
      state.inviteCode = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(doSignIn.fulfilled, (state, action) => {
      const token = action.payload?.access_token;
      const companies = action.payload?.companies;
      if (token) {
        Cookies.set(TOKEN_NAME, token);
        state.authenticated = true;
        state.userData = parseToken(token);
      }
      if (companies) {
        state.companies = companies;
      }
    });
    builder.addCase(doSignInCompany.fulfilled, (state, action) => {
      const token = action.payload?.access_token;
      if (token) {
        Cookies.set(TOKEN_NAME, token);
        state.authenticated = true;
        state.userData = parseToken(token);
      }
    });
    builder.addCase(doSignUp.fulfilled, (state, action) => {
      const token = action.payload?.access_token;
      if (token) {
        Cookies.set(TOKEN_NAME, token);
        state.authenticated = true;
        state.userData = parseToken(token);
        if (state.inviteCode) {
          state.redirectUrl = null;
          state.inviteCode = null;
        }
      }
    });
    builder.addCase(doGetProfile.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doGetProfile.fulfilled, (state, action) => {
      state.isFetching = false;
      state.user = action.payload;
    });
    builder.addCase(doGetProfile.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doUpdateUploadOrderTemplate.fulfilled, (state, action) => {
      state.isFetching = false;
      state.user = action.payload;
    });
  },
});

const { actions, reducer: authReducer } = authSlice;
export const { doLogout, setRedirectUrl, setInviteCode } = actions;
export default authReducer;
